<template>
  <div v-loading="$wait.waiting(_uid)" class="card">
    <div class="card-content">
      <div class="text-right control-button-wrapper pt-xxs">
        <router-link :to="{ name: 'my_events@index' }">
          <button type="button" class="btn btn-cancel btn-primary btn-wd">
            Cancel
          </button>
        </router-link>
        <acl :roles="canCreateEvent()">
          <button
            type="button"
            class="btn btn-info btn-fill btn-wd submit-button"
            :class="{ loading: $wait.waiting(_uid) }"
            @click="handleCreate"
          >
            Create
            <i
              v-show="$wait.waiting(_uid)"
              class="fas fa-circle-notch loading-icon"
            />
          </button>
        </acl>
      </div>

      <EventForm :event="event" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import MyService from "@app/services/my";
import EventForm from "@components/Events/Components/Form.vue";
import { getStorageData } from "@/utils/storage";
import parseSettings from "@providers/parseSettings";
import rolesConstants from "@/components/acl/roles";

export default {
  components: {
    EventForm,
  },
  data() {
    return {
      event: {
        description: null,
        notes: null,
        issued_at: null,
        expiry_at: null,
        attachments: [],
        files: [],
        manager: null,
        trainee: null,
        reminders: [
          { key: "days", value: "0" },
          { key: "days", value: "0" },
          { key: "days", value: "0" },
        ],
      },
    };
  },
  computed: {
    ...mapGetters("loadingStore", { isLoading: "loading" }),
  },
  created() {
    this.ROLE_SUPER = rolesConstants.ROLE_SUPER;
    this.ROLE_ADMIN = rolesConstants.ROLE_ADMIN;
    this.ROLE_COMPANY_MANAGER = rolesConstants.ROLE_COMPANY_MANAGER;
    this.ROLE_TRAINING_MANAGER = rolesConstants.ROLE_TRAINING_MANAGER;
    this.ROLE_TRAINEE = rolesConstants.ROLE_TRAINEE;
    this.ROLE_SUPPORT = rolesConstants.ROLE_SUPPORT;
    this.ROLE_CTOPS = rolesConstants.ROLE_CTOPS;
  },
  async mounted() {
    try {
      this.$wait.start(this._uid);
    } catch (error) {
      this.addNewError(error);
    } finally {
      this.$wait.end(this._uid);
    }
  },
  methods: {
    ...mapActions("loadingStore", ["setLoading"]),
    ...mapActions("errorStore", ["addNewError"]),
    parseSettings,
    canCreateEvent() {
      const roleList = [];

      roleList.push(this.ROLE_COMPANY_MANAGER);
      roleList.push(this.ROLE_TRAINING_MANAGER);

      const company = getStorageData("company");
      const companySettings = this.parseSettings(company.settings);

      if (companySettings.events_documents) {
        roleList.push(this.ROLE_TRAINEE);
        return roleList;
      }

      return roleList;
    },
    async handleCreate() {
      try {
        this.$wait.start(this._uid);

        const event = await MyService.storeEvent(this.event);

        this.$notify({
          message: "Data updated successfully!",
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "success",
        });

        this.$router.push({
          name: "my_events@show",
          params: { id: event.id },
        });
      } catch (error) {
        this.addNewError(error);
      } finally {
        this.$wait.end(this._uid);
      }
    },
  },
};
</script>

<style lang="scss"></style>
